import Image from 'next/image'
import { useContext } from 'react'
import { EDevice } from '../../containers/MainLayout'
import AppContext from '../../context/AppContext'
import { BannerCss, PictureCss } from './index.css'
interface IProps {
	children: React.ReactNode
	banner: string
	bannerMobile: string
	alt: string
}

export default function Banner({
	children,
	banner,
	bannerMobile,
	alt
}: IProps) {
	const { breakpoint } = useContext(AppContext)
	return (
		<BannerCss>
			<PictureCss>
				{breakpoint === EDevice.MOBILE ? (
					<Image
						src={bannerMobile}
						alt={alt}
						width={600}
						height={722}
						objectFit='cover'
					/>
				) : (
					<Image
						src={banner}
						alt={alt}
						width={1424}
						height={562}
						objectFit='cover'
					/>
				)}
			</PictureCss>
			{children}
		</BannerCss>
	)
}
